import React from "react";
import { motion } from "framer-motion";
import {
  ShieldAlert,
  Users,
  MapPin,
  AlertTriangle,
  Info,
  Phone,
  Search,
} from "lucide-react";
import "./MissingChildrenPolicy.css";

const MissingChildrenPolicy = () => {
  const sections = [
    {
      icon: <Users className="policy-icon1123 blue1123" />,
      title: "1. Responsibility",
      description:
        "All children under the age of 18 must be accompanied and supervised by a parent, legal guardian, or a responsible adult designated by the parent. TPL does not provide child supervision or childcare services. Guardians are expected to stay close to their children at all times.",
    },
    {
      icon: <MapPin className="policy-icon1123 green1123" />,
      title: "2. Prevention Recommendations",
      description: (
        <ul className="policy-list1123">
          <li>Keep children within sight at all times.</li>
          <li>Set a designated meeting spot in case of separation.</li>
          <li>
            Provide your child with an ID tag including your name and contact
            number.
          </li>
        </ul>
      ),
    },
    {
      icon: <AlertTriangle className="policy-icon1123 orange1123" />,
      title: "3. If a Child Goes Missing",
      description:
        "If a missing child is reported,Aattum TPL staff may assist by broadcasting internal alerts with basic child descriptions, notifying event security to monitor exits, and contacting local law enforcement if deemed necessary. However, this assistance is discretionary and does not constitute an assumption of responsibility.",
    },
    {
      icon: <ShieldAlert className="policy-icon1123 red1123" />,
      title: "4. Acknowledgment of Responsibility",
      description:
        "By attending the Aattum Talent Premier League event, parents and guardians agree that they are solely responsible for the care and safety of their children. They also acknowledge that TPL holds no legal or moral liability in the event of a missing child or related incident.",
    },
    {
      icon: <Phone className="policy-icon1123 purple1123" />,
      title: "5. Emergency Contact Procedure",
      description:
        "In case of an emergency, parents should immediately approach the nearest TPL help desk or event staff. Emergency contact numbers will be displayed across all major event zones for quick communication and coordination.",
    },
    {
      icon: <Search className="policy-icon1123 teal1123" />,
      title: "6. Lost & Found Assistance",
      description:
        "Aattum TPL maintains a dedicated Lost & Found booth at the venue for reporting and locating missing persons or belongings. Parents are advised to promptly notify this booth if their child is missing, to help facilitate quick action and communication.",
    },
  ];

  return (
    <div className="missing-page1123">
      <motion.div
        initial={{ opacity: 0, y: -30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="missing-header1123"
      >
        <h1>Aattum Talented Premier League</h1>
        <p>Missing Children Policy</p>
        <div className="header-line1123"></div>
      </motion.div>

      <motion.div
        className="notice1123"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.5 }}
      >
        <Info className="notice-icon1123" />
        <p>
          <strong>Important Notice:</strong> Parents and guardians are fully
          responsible for the supervision and safety of their children at all
          times during the event. Talent Premier League is not responsible for
          any incidents involving missing children.
        </p>
      </motion.div>

      <div className="missing-grid1123">
        {sections.map((section, index) => (
          <motion.div
            key={index}
            className="missing-card1123"
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
            viewport={{ once: true }}
          >
            <div className="missing-title1123">
              {section.icon}
              <h2>{section.title}</h2>
            </div>
            <div className="missing-desc1123">{section.description}</div>
          </motion.div>
        ))}
      </div>

      
    </div>
  );
};

export default MissingChildrenPolicy;
